<template>
    <el-dialog
        :title="isForm ? '编辑服务' : '详情'"
        :model-value="modelValue"
        width="640px"
        @opened="dialogOpened"
        @close="closed"
        :close-on-click-modal="false"
    >
        <el-form
            ref="formRef"
            :model="formData"
            v-loading="loading"
            :rules="formRules"
            label-width="150px"
            label-suffix="："
            style="max-width: 560px"
        >
            <!-- 单位：普通下拉选择 -->
            <el-form-item label="单位" prop="school">
                <el-select
                    v-if="isForm"
                    v-model="formData.school"
                    placeholder="请选择单位"
                    style="width: 100%"
                    @change="handleSchoolChange"
                >
                    <el-option v-for="item in schoolOptionLists" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                <span v-else>{{ getSchoolName(formData.school) || '-' }}</span>
            </el-form-item>

            <!-- 区域：根据单位children动态渲染 -->
            <el-form-item label="区域" prop="building">
                <el-select v-if="isForm" v-model="formData.building" placeholder="请选择区域" style="width: 100%" clearable>
                    <el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                <span v-else>{{ getAreaName(formData.building) || '-' }}</span>
            </el-form-item>

            <el-form-item label="AppKey" prop="appKey">
                <el-input v-model="formData.appKey" placeholder="请输入AppKey" v-if="isForm" />
                <span v-else>{{ formData.appKey || '-' }}</span>
            </el-form-item>

            <el-form-item label="AppSecret" prop="appSecret">
                <el-input v-model="formData.appSecret" placeholder="请输入AppSecret" v-if="isForm" />
                <span v-else>{{ formData.appSecret || '-' }}</span>
            </el-form-item>
        </el-form>

        <template #footer>
            <span class="dialog-footer" v-if="isForm">
                <el-button @click="closed">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
            <span class="dialog-footer" v-else>
                <el-button type="primary" @click="closed">关闭</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script setup>
import { defineEmits, defineProps, ref, computed } from 'vue'
import { ElMessage } from 'element-plus'
import { addOpenAppManage, putOpenAppManage } from '@/api/open_app.js'
import { getOptionTree } from '@/api/room.js'
import { getSchoolOptionLists } from '@/api/school'
import { getBuildingTree } from '@/api/building.js'
const props = defineProps({
    modelValue: { type: Boolean, required: true },
    isForm: { type: Boolean, default: false },
    detailData: { type: Object, default: () => ({}) }
})

const emits = defineEmits(['update:modelValue', 'updateForm'])
const schoolOptionLists = ref([])
const getOptionData = async () => {
    schoolOptionLists.value = await getSchoolOptionLists()
}
getOptionData()
const loading = ref(false)
const submitLoading = ref(false)
const formRef = ref(null)

// 提交字段不变
const formData = ref({
    school: '',
    building: '',
    appKey: '',
    appSecret: ''
})

// 验证规则
const formRules = ref({
    school: [{ required: true, message: '请选择单位', trigger: 'change' }],
    // building: [{ required: true, message: '请选择区域', trigger: 'change' }],
    appKey: [{ required: true, message: '请输入AppKey', trigger: 'blur' }],
    appSecret: [{ required: true, message: '请输入AppSecret', trigger: 'blur' }]
})

const areaList = ref([])
const school_building = ref([])
// 当前选中单位的区域列表
const currentAreaListFn = async () => {
    school_building.value = await getBuildingTree({ school: formData.value.school })
    areaList.value = school_building.value?.[0]?.children || []
    formData.value.building = ''
}

// 切换单位 → 清空区域
function handleSchoolChange() {
    currentAreaListFn()
}

// 详情回显单位名称
function getSchoolName(id) {
    const item = schoolOptionLists.value.find((i) => i.id === id)
    return item?.name || ''
}

// 详情回显区域名称
function getAreaName(id) {
    const item = areaList.value.find((i) => i.id === id)
    return item?.name || ''
}

// 打开赋值
function dialogOpened() {
    loading.value = true
    const data = props.detailData || {}
    Object.keys(formData.value).forEach((key) => {
        formData.value[key] = data[key] ?? ''
    })
    currentAreaListFn()
    if (!areaList.value.some((item) => item.id === formData.value.building)) {
        formData.value.building = ''
        handleSchoolChange()
    }
    loading.value = false
}

// 关闭重置
const closed = () => {
    emits('update:modelValue', false)
    formRef.value?.resetFields()
}

// 提交接口
async function onConfirm() {
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        try {
            const params = { ...formData.value }
            if (!params.building) {
                params.building = school_building.value?.[0]?.id || ''
            }
            if (props.detailData?.id) {
                await putOpenAppManage({ id: props.detailData.id, ...params })
            } else {
                await addOpenAppManage(params)
            }
            ElMessage.success('操作成功！')
            emits('updateForm')
            closed()
        } catch (err) {
            console.log(err)
        } finally {
            submitLoading.value = false
        }
    })
}
</script>

<style lang="scss" scoped></style>
